import React, {useEffect} from "react";
import {IProductSegment} from "../../models/Storefront";
import {DefaultButton, Panel, PanelType, PrimaryButton, Spinner, Stack, TextField} from "@fluentui/react";
import RichTextField from "../Common/RichTextField";
import NumberField from "../Inputs/NumberField";
import {
    useGetSegmentByIdQuery, useSaveCustomStorefrontSegmentMutation
} from "../../store/endpoints/ProductCategorizationEndpoints";
import ImageEditor from "../Inputs/ImageEditor";

export interface IProductSegmentDetailsPanelProps {
    isOpen: boolean;
    segmentIdentifier: string;
    onDismiss: () => void;
}
const ProductSegmentDetailsPanel: React.FC<IProductSegmentDetailsPanelProps> = (props) => {
    
    const [effectiveSegment, setEffectiveSegment] = React.useState<IProductSegment>();
    const segment = useGetSegmentByIdQuery({ segmentIdentifier: props.segmentIdentifier }, {skip: !props.segmentIdentifier || props.segmentIdentifier === ''});
    const [saveSegment] = useSaveCustomStorefrontSegmentMutation()
    const [saving, setSaving] = React.useState(false);

    useEffect(() => {
        return () => {
            setSaving(false);
            setEffectiveSegment(undefined)
        }
    }, []);
    useEffect(() => {
        if(segment.data) {
            setEffectiveSegment(segment.data);
        }
    }, [props.segmentIdentifier, segment.data]);
    return(<>
        <Panel
            onOuterClick={() => {
                console.log("swallowing modal close event")
            }}
            isOpen={props.isOpen}
            headerText={'Segment Details'}
            isFooterAtBottom={true}
            type={PanelType.medium}
            onDismiss={props.onDismiss}
            onRenderFooterContent={() => (
                <div style={{'paddingTop': '1em', backgroundColor: 'white'}}>
                    <PrimaryButton
                        disabled={saving}
                        text='Save Segment'
                        style={{ width: '100%', margin: '10px 0' }}
                        onClick={() => {
                            if (!effectiveSegment) return;
                            setSaving(true);
                            saveSegment({segment: effectiveSegment}).unwrap().then(() => {
                                setSaving(false);
                                props.onDismiss();
                            }).catch(() => {
                                setSaving(false);
                            });
                        }}
                    />
                    <DefaultButton text='Close' style={{ width: '100%', marginBottom: '10px' }} onClick={props.onDismiss} />
                </div>
            )}
        >{effectiveSegment ?
            <Stack tokens={{childrenGap: '1em'}}>
                <TextField label='Display Name' value={effectiveSegment.label} onChange={(e, v) => setEffectiveSegment({...effectiveSegment, label: v ?? ''})} />
                <div className={'labeled-image-container'}>
                    <ImageEditor height={48} label={'Icon'} imageId={`$${effectiveSegment.identifier}_icon`} imageType={'productSegmentIcon'} onChange={(v) => setEffectiveSegment({...effectiveSegment, smallImageUrl: v ?? ''})} value={effectiveSegment.smallImageUrl} />
                </div>
                <div className={'labeled-image-container'}>
                    <ImageEditor label={'Image'} imageId={`${effectiveSegment.identifier}_image`} imageType={'productSegmentImage'} onChange={(v) => setEffectiveSegment({...effectiveSegment, largeImageUrl: v ?? ''})} value={effectiveSegment.largeImageUrl} />
                </div>
                <RichTextField label='Description' value={effectiveSegment.description} onChange={(v) => setEffectiveSegment({...effectiveSegment, description: v})} />
                <NumberField label={'Display Priority'} value={effectiveSegment.displayPriority} onChange={(v) => setEffectiveSegment({...effectiveSegment, displayPriority:v })} />
            </Stack>
            : <Spinner>Loading</Spinner>}
        </Panel>
    </>);
}
export default ProductSegmentDetailsPanel;